import { useSelector } from 'react-redux';
import { navSelector } from 'common/store/modules/competition-nav/selectors';

/**
 * Using the nav selector to target elements in the store, return the
 * seasonsFiltered array based upon the nav's current set tournament
 * filters. Config variables are used to define the first season
 * a club is playing for a particular tournament
 *
 * @param {Array} competitions - the current competitions objects stored as an array - array
 * @param {Array} seasons - the current seasons objects stored as an array - array
 * @returns {Array} - Contains the filtered seasons
 */
export function useFilterSeasonsSelector({ competitions, seasons }) {
    const nav = useSelector(navSelector);

    const compAbbr = competitions?.find(
        (competition) => competition.id === nav?.competition?.id
    )?.code;

    const firstSeasonIndex =
        compAbbr &&
        window[compAbbr + '_FIRST_COMP_SEASON_ID']?.length &&
        seasons?.findIndex(
            (season) =>
                season.providerId === window[compAbbr + '_FIRST_COMP_SEASON_ID']
        );

    let seasonsFiltered;
    if (firstSeasonIndex >= 0) {
        seasonsFiltered = seasons.filter(
            (season, index) => index <= firstSeasonIndex
        );
    } else {
        seasonsFiltered = seasons;
    }

    return seasonsFiltered;
}